var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutcome6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F43E3E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1049_108253",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1049_108253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3125 24.9211H21.6875V22.1579H24.5V18.8421H21.6875V16.0789H18.3125V18.8421H15.5V22.1579H18.3125V24.9211ZM20 31C17.3938 30.3553 15.2422 28.8862 13.5453 26.5928C11.8484 24.2993 11 22.8579 11 20.0579V14.0131C11 13.5941 11.2612 13.2196 11.6543 13.0747L19.6543 10.1274C19.8774 10.0452 20.1226 10.0452 20.3457 10.1274L28.3457 13.0747C28.7388 13.2196 29 13.5941 29 14.0131V20.0579C29 22.8579 28.1516 24.2993 26.4547 26.5928C24.7578 28.8862 22.6062 30.3553 20 31Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutcome6);
export default __webpack_public_path__ + "static/media/outcome6.167b627da147f629bd02746ba41e7fd2.svg";
export { ForwardRef as ReactComponent };